import React, { useContext, useEffect, useState } from "react";
import TopHeader from "../../components/layouts/TopHeader";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import Button from "../../components/ui/Button";
import PaymentChart from "./PaymentChart";
import PaymentRecord from "./PaymentRecord";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import authContext from "../../context/authContext";
import toast from "react-hot-toast";
import { getFrequencyDates, isDateFinalized } from "../../utils/Helper";
import { Tooltip as ReactTooltip } from "react-tooltip";
import dummyUser from "../../assets/images/menu/account.svg";
import addIcon from '../../assets/images/add-icon.svg';
import Checkbox from "../../components/layouts/CheckBox";
import CustomReactSelect from "../../components/ui/CustomReactSelect";
import moment from "moment";
import PageLayout from "../../components/ui/PageLayout";
import chevRight from '../../assets/images/chev-right.svg';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calLogo from "../../assets/images/calender.svg";

const monthsOptions = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];





function Payment() {

  const unAssignedExpenses = useMakeRequest();
  const hhMembers = useMakeRequest();
  const markAsPaid = useMakeRequest();
  const sendReminderUnpaidBalance = useMakeRequest();
  const getPaymentMethodLinks = useMakeRequest();
  const deletePaymentMethodLinks = useMakeRequest();
  const savePaymentMethod = useMakeRequest();
  const paymentSummary = useMakeRequest();


  let profile: any = useContext(authContext);
  profile = profile?.data;

  console.log("profile: ", profile)

  const [cumulativeBalance, setCumulativeBalance] = useState<string | null>("");
  const [jointTotal, setJointTotal] = useState<string | number>("0");
  const [members, setMembers] = useState<any>([]);
  const [payerOptions, setPayerOptions] = useState<any>([]);
  const [recepintOption, setRecepintOption] = useState<any>([]);

  const [totalPaymentMade, setTotalPaymentMade] = useState<any>(0);
  const [totalPaymentReceived, setTotalPaymentReceived] = useState<any>(0);
  const [totalPaymentMadeBy, setTotalPaymentMadeBy] = useState<any>([]);
  const [totalPaymentReceivedBy, setTotalPaymentReceivedBy] = useState<any>([]);
  console.log("payerOptions", payerOptions)
  const currentMonthNumber = moment().month() + 1;
  const defaultMonthObj = monthsOptions.find((m) => m.value === currentMonthNumber) || monthsOptions[0];

  const [selectedMonth, setSelectedMonth] = useState<any>(defaultMonthObj);
  const [startDate, setStartDate] = useState<Date | null>(moment().startOf("month").toDate());
  const [endDate, setEndDate] = useState<Date | null>(moment().endOf("month").toDate());
  const [unAssignedData, setUnAssignedData] = useState([])
  const [finalizedMonth, setFinalizedMonth] = useState<any[]>([])
  const [visibleUnpaidExpense, setVisibleUnpaidExpense] = useState(false);
  const [visiblePaymentMethod, setVisiblePaymentMethod] = useState(false);
  const [paymentLinksForSelectedUser, setPaymentLinksForSelectedUser] = useState<any>([]);
  const [paymentMethodInput, setPaymentMethodInput] = useState('');
  const [paymentLink, setPaymentLink] = useState('');
  const [paypalUsername, setPaypalUsername] = useState("");
  const [paymentMethodLinkError, setPaymentMethodLinkError] = useState("");




  const [uiState, setUiState] = useState<any>([]);

  const [isFinalized, setIsFinalized] = useState(false);

  const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
    totalPaymentMade: false,
    totalPaymentReceived: false
  });

  const toggleSection = (section: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  }

  useEffect(() => {
    if (unAssignedData?.length > 0) {
      const ui = unAssignedData.flatMap((cat: any) =>
        cat.expenses.map((exp: any) => {
          let selectedPayer = null;

          // ⭐ If it is a joint account expense → auto-select Joint Account
          if (exp.is_joint_account === 1) {
            selectedPayer = recepintOption.find((p: any) => p.value === "-1");
          }
          // Otherwise use payer from API
          else if (exp.payer && exp.payer !== 0) {
            selectedPayer = recepintOption.find((p: any) => p.value === exp.payer);
          }

          return {
            category_id: cat.category_id,
            expenseId: exp.id,
            selectedPayer,
            isPaid: exp.is_unpaid === 0,
          };
        })
      );

      setUiState(ui);
    }
  }, [unAssignedData, recepintOption]);


  const isCurrentMonth = React.useMemo(() => {
    const now = moment();
    const currentMonthNum = now.month() + 1;
    const currentYearNum = now.year();

    const selMonthVal = selectedMonth ? selectedMonth.value : currentMonthNum;
    const selYearVal = startDate ? moment(startDate).year() : currentYearNum;

    return selMonthVal === currentMonthNum && selYearVal === currentYearNum;
  }, [selectedMonth, startDate]);

  const handleSelectPayer = (expenseId: number, selectedOption: any) => {
    if (!isCurrentMonth) return;
    console.log("selectedOption: ", selectedOption)
    setUiState((prev: any) =>
      prev.map((item: any) =>
        item.expenseId === expenseId
          ? { ...item, selectedPayer: selectedOption }
          : item
      )
    );
  };

  const handleTogglePaid = async (expenseId: number) => {
    if (!isCurrentMonth) {
      toast.error("You can only mark expenses as paid for the current month.");
      return;
    }
    const current = uiState.find((x: any) => x.expenseId === expenseId);

    if (!current?.selectedPayer) {
      toast.error("Please select a payer first.");
      return; // 🚫 stop toggle
    }

    const newPaid = !current.isPaid;

    // 🔄 Optimistic UI update
    setUiState((prev: any) =>
      prev.map((item: any) =>
        item.expenseId === expenseId ? { ...item, isPaid: newPaid } : item
      )
    );

    try {
      const res = await markAsPaid.makeRequest({
        url: ApiConstants.markAsPaidExpenses,
        type: "POST",
        payload: {
          e_id: expenseId,
          is_paid: newPaid,
          payer: current.selectedPayer.value,
        },
      });

      if (!res?.status) {
        throw new Error(res?.message || "Failed to update payment status");
      } else {
        console.log("res: ", res)
        APIcallUnassignedExpenceList();
      }
    } catch (err: any) {
      toast.error(err.message || "Something went wrong.");

      // ⏪ rollback if API fails
      setUiState((prev: any) =>
        prev.map((item: any) =>
          item.expenseId === expenseId ? { ...item, isPaid: !newPaid } : item
        )
      );
    }
  };


  const STATIC_PAYER_OPTIONS = [
    { value: "01", label: "Joint Account" },
  ];


  useEffect(() => {
    if (profile?.hh_member?.household?.uuid) {
      hhMembers.makeRequest({
        url: ApiConstants?.GetHouseholdMembers,
        payload: { hh_id: profile?.hh_member?.household?.uuid },
      });
      getPaymentSummary();
    }
  }, [profile?.hh_member?.household?.uuid]);

  const getPaymentSummary = () => {
    paymentSummary.makeRequest({
      url: ApiConstants?.paymentSummary,
      payload: { hh_id: profile?.hh_member?.household?.id },
    });
  }

  useEffect(() => {
    if (hhMembers?.status) {
      console.log("hhMembers: ", hhMembers)
      const transformedData = hhMembers?.data?.data
        ?.filter((item: any) => {
          const user = item?.user;

          const isCurrentUser = profile?.id === user?.id;
          const isTempNotLoggedIn =
            user?.is_logined === 0 && user?.is_temp_user === 1;

          return isCurrentUser || isTempNotLoggedIn;
        })
        ?.map((item: any) => ({
          value: item?.user?.id,
          label:
            profile?.id === item?.user?.id
              ? "Me"
              : item?.user?.name,
        }));

      const memberData = hhMembers?.data?.data?.map((item: any) => ({
        value: item?.user?.id,
        label: profile?.id === item?.user?.id ? `Me` : item?.user?.name,
      }));
      console.log("memberData: ", memberData)

      // Merge with static options
      setPayerOptions([...transformedData, ...STATIC_PAYER_OPTIONS]);
      setRecepintOption([...memberData, ...STATIC_PAYER_OPTIONS]);
    }
  }, [hhMembers?.status]);

  useEffect(() => {
    if (paymentSummary?.status) {
      console.log("paymentSummary: ", paymentSummary?.data?.data)
      setTotalPaymentMade(paymentSummary?.data?.data?.total_payments_made)
      setTotalPaymentReceived(paymentSummary?.data?.data?.total_payments_received)
      setTotalPaymentMadeBy(paymentSummary?.data?.data?.payments_made_by)
      setTotalPaymentReceivedBy(paymentSummary?.data?.data?.payments_received_by)
    }
  }, [paymentSummary])



  useEffect(() => {
    APIcallUnassignedExpenceList(selectedMonth, startDate, endDate);
  }, []);

  const APIcallUnassignedExpenceList = (
    mOpt = selectedMonth,
    sDate = startDate,
    eDate = endDate
  ) => {
    const payload: any = {};
    if (mOpt) {
      payload.month = mOpt.value;
      payload.year = sDate ? moment(sDate).year() : moment().year();
    }
    if (sDate) {
      payload.start_date = moment(sDate).format("YYYY-MM-DD");
    }
    if (eDate) {
      payload.end_date = moment(eDate).format("YYYY-MM-DD");
    }

    unAssignedExpenses.makeRequest({ url: ApiConstants?.UnAssignedExpenses, type: 'POST', payload }).then((res) => {
      if (res?.status) {
        setUnAssignedData(res?.data?.category_wise_data || []);
        let category_wise_data = res?.data?.category_wise_data;
        const finalizedMonths = res?.data?.finalized_months || [];
        let finalized = false;

        if (finalizedMonths.length > 0) {
          if (category_wise_data?.length > 0) {
            category_wise_data.forEach((cat: any) => {
              cat.expenses?.forEach((exp: any) => {
                const expDate = exp?.s_date || exp?.e_date || exp?.date;
                if (expDate && isDateFinalized(expDate, finalizedMonths)) {
                  finalized = true;
                }
              });
            });
          }

          if (!finalized) {
            const filterDate = sDate ? moment(sDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            if (isDateFinalized(filterDate, finalizedMonths)) {
              finalized = true;
            }
          }

          if (!finalized && finalizedMonths.length > 0) {
            finalized = true;
          }
        }

        console.log("finalized: ", finalized);
        console.log("finalizedMonths: ", finalizedMonths);
        setIsFinalized(finalized);
        setFinalizedMonth(finalizedMonths);
        setMembers(res?.data?.member_balances || []);
        setCumulativeBalance(res?.data?.comulativeBalance);
        setJointTotal(res?.data?.joint_total);
      }
    });
  };

  const handleMonthChange = (option: any) => {
    setSelectedMonth(option);
    let newStart = startDate;
    let newEnd = endDate;
    if (option) {
      const yearToUse = startDate ? moment(startDate).year() : moment().year();
      newStart = moment().year(yearToUse).month(option.value - 1).startOf("month").toDate();
      newEnd = moment().year(yearToUse).month(option.value - 1).endOf("month").toDate();
      setStartDate(newStart);
      setEndDate(newEnd);
    }
    APIcallUnassignedExpenceList(option, newStart, newEnd);
  };

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
    let mOpt = selectedMonth;
    if (date) {
      const mNum = moment(date).month() + 1;
      mOpt = monthsOptions.find((m) => m.value === mNum) || null;
      setSelectedMonth(mOpt);
    }
    APIcallUnassignedExpenceList(mOpt, date, endDate);
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
    APIcallUnassignedExpenceList(selectedMonth, startDate, date);
  };


  useEffect(() => {
    getPaymentMethodLinks.makeRequest({
      payload: { hh_id: profile?.hh_member?.household?.id },
      url: ApiConstants?.getPaymentMethodLinks,
    }).then((res) => {
      if (res?.data) {
        let arr = res?.data.sort((a: { user_id: any; }, b: any) => (a.user_id === profile?.id ? 1 : -1));
        setPaymentLinksForSelectedUser(arr)
      }
    })
  }, [])


  const unAssignedExpData =
    unAssignedData
      ?.map((cat: any) => ({
        ...cat,
        expenses: cat.expenses.filter((exp: any) => {
          if (!isCurrentMonth) {
            // For other months, user can ONLY see unpaid expenses
            return exp.is_unpaid === 1;
          }
          // For current month, standard filter logic
          return !(!exp.is_visible_in_payment_screen && exp.is_unpaid === 0);
        }),
      }))
      .filter((cat: any) => cat.expenses.length > 0) || [];

  const onPressSend = () => {
    toast.promise(
      sendReminderUnpaidBalance.makeRequest({
        url: ApiConstants.sendReminder,
        payload: {
          hh_id: profile?.hh_member?.household?.id,
          start_date: moment(finalizedMonth[0]?.s_date).format('YYYY-MM-DD'),
          end_date: moment(finalizedMonth[0]?.e_date).format('YYYY-MM-DD'),
          reminder_type: 2
        },
      }),
      {
        loading: 'Processing...',
        success: (data: any) => data.message,
        error: (error: any) => error.message,
      }
    );
  }

  const _addPaymentMethod = (payload: any) => {

    savePaymentMethod.makeRequest({
      payload: payload,
      url: ApiConstants?.savePaymentMethod, // <-- replace with your API constant name
    }).then((res) => {
      setPaymentLinksForSelectedUser([])
      getPaymentMethodLinks.makeRequest({
        payload: { hh_id: profile?.hh_member?.household?.id },
        url: ApiConstants?.getPaymentMethodLinks,
      }).then((res) => {
        if (res?.data) {
          let arr = res?.data.sort((a: { user_id: any; }, b: any) => (a.user_id === profile?.id ? 1 : -1));
          setPaymentLinksForSelectedUser(arr)
        }
      })
    })
    setPaypalUsername("")
    setPaymentMethodInput("")
  };


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setPaypalUsername(val);
  };


  const getSummaryList = (paymentsBy: any[]) => {
    const membersList = hhMembers?.data?.data || [];
    const list = membersList.map((item: any) => {
      const isMe = profile?.id && String(profile.id) === String(item?.user?.id);
      const labelName = isMe ? "Me" : item?.user?.name;
      const userId = item?.user?.id;

      const paymentEntry = paymentsBy?.find(
        (p: any) => String(p.user_id) === String(userId)
      );
      const amount = paymentEntry ? paymentEntry.amount : 0;

      return {
        label: labelName,
        amount: amount
      };
    });

    const jointEntry = paymentsBy?.find(
      (p: any) => String(p.user_id) === "-1" || String(p.user_id) === "01" || p.name?.toLowerCase().includes("joint")
    );
    const jointAmount = jointEntry ? jointEntry.amount : 0;

    list.push({
      label: "Joint Accounts",
      amount: jointAmount
    });

    return list;
  };

  //  const is_finalized = isDateFinalized(date, expenses?.data?.data?.finalized_months || []);
  if (unAssignedExpenses.loading || hhMembers.loading) {
    return <div>Loading...</div>
  }

  console.log("isFinalized: ", isFinalized)
  console.log("unAssignedExpData?.length: ", unAssignedExpData?.length)

  return (
    <PageLayout headerName='Payments' onlyTitle={false}>
      <div className="payment-page m-0">
        {/* <div className="m-0">
          <TopHeader headerName="Payment" />
          </div> */}

        {/* {!isFinalized ?
          <>
            {unAssignedExpData?.length > 0 ? <div className="page-padding-x">You haven't finalized the contribution yet. Kindly finalize it before making the payment.</div> : <div className="page-padding-x">You don’t have any unpaid expenses, or you haven’t finalized the contribution yet.</div>}

          </>
          : */}
        <div>
          <div className="page-padding-x">
            <div className="com-input-grp d-flex justify-content-between mt-3 mb-2">
              <label className="form-label-larg">Finalized Balances
                <abbr
                  data-tooltip-id={'FinalizedBalancesInfo'}
                  className="text-decoration-none cursor-pointer"
                >
                  {" "}
                  <i className="icon-info ms-2"></i>
                </abbr></label>
              <ReactTooltip
                style={{
                  zIndex: "1",
                  wordBreak: "break-word",
                  maxWidth: "90%",
                }}
                id={'FinalizedBalancesInfo'}
                place="bottom"
                content={"Finalized balances are the cumulative total of all balances that have been finalized on the Contributions screen and all payments. If a month has not yet been finalized on the Contributions screen, the balances will not appear on the Payments screen."}
              />
              <label className="form-label-larg">${!isFinalized ? 0 : cumulativeBalance}</label>
            </div>
            {members && members.length > 0 && members.map((ele: any) => {
              return (
                <div className="member-balance-item">
                  <div className="member-info">
                    <img
                      src={ele?.profilePic || dummyUser}
                      alt={ele?.member_name}
                      className="member-avatar"
                    />
                    <label className="member-name">
                      {ele?.member_name}
                    </label>
                  </div>
                  {!isFinalized ?
                    <label className={`member-balance`}>
                      $0
                    </label>
                    :
                    <label className={`member-balance ${ele?.balance >= 0 ? 'positive' : 'negative'}`}>
                      {ele?.balance >= 0 ? '+' : ''}{ele?.balance}
                    </label>
                  }
                </div>
              )
            })}

            {/* Joint Accounts Balance Row */}
            <div className="member-balance-item">
              <div className="member-info">
                <img
                  src={dummyUser}
                  alt="Joint Accounts"
                  className="member-avatar"
                />
                <label className="member-name">
                  Joint Accounts
                </label>
              </div>
              {!isFinalized ?
                <label className={`member-balance`}>
                  $0
                </label>
                :
                <label className={`member-balance ${Number(jointTotal) >= 0 ? 'positive' : 'negative'}`}>
                  {Number(jointTotal) >= 0 ? '+' : ''}{jointTotal}
                </label>
              }
            </div>


            <div className="com-input-grp d-flex mt-3">
              <label className="form-label-secondary">Notify members of unpaid balances</label>
            </div>

            <Button
              onClick={onPressSend}
              className="com-btn-arraow mb-3">
              Send reminder
            </Button>
          </div>


          <div className="page-padding-x">
            <div className="payment-form mb-4">
              <div
                className="form-header"
                role="button"
                tabIndex={0}
                onClick={() => setVisibleUnpaidExpense(!visibleUnpaidExpense)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setVisibleUnpaidExpense(!visibleUnpaidExpense);
                  }
                }}
              >
                <h2 className="dropdown-title">Assign Unpaid Expenses</h2>
                <img src={addIcon} alt="Arrow" className="arrow-icon" />
              </div>

              {visibleUnpaidExpense && (
                <div className="col-12 p-3">
                  <div className="filter-controls mb-3">
                    <div className="com-input-grp mb-3">
                      <CustomReactSelect
                        options={monthsOptions}
                        className="com-r-select"
                        classNamePrefix="com-r-select"
                        placeholder="Select Month"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                        }}
                      />
                    </div>

                    <div className="row gy-3 mb-3">
                      <div className="col-6">
                        <div className="com-input-grp">
                          <label className="form-label d-block">Start Date</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="MM/DD/YYYY"
                            dateFormat="MM/dd/yyyy"
                            onKeyDown={(e: any) => e.preventDefault()}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                            selected={startDate}
                            showIcon
                            icon={<img className="calIcon" src={calLogo} alt="Calendar" />}
                            onChange={handleStartDateChange}
                          />
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="com-input-grp">
                          <label className="form-label d-block">End Date</label>
                          <DatePicker
                            className="form-control"
                            placeholderText="MM/DD/YYYY"
                            dateFormat="MM/dd/yyyy"
                            onKeyDown={(e: any) => e.preventDefault()}
                            showYearDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={50}
                            selected={endDate}
                            showIcon
                            icon={<img className="calIcon" src={calLogo} alt="Calendar" />}
                            onChange={handleEndDateChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {unAssignedExpenses.loading ? (
                    <div className="text-center py-3">
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Loading expenses...
                    </div>
                  ) : unAssignedExpData?.length > 0 ? (
                    unAssignedExpData.map((ele: any) => {
                      return ele.expenses.map((expense: any) => {
                        const uiExp = uiState.find((x: any) => x.expenseId === expense.id);
                        return (
                          <div key={expense.id} className="expense-item">
                            <div className="expense-info">
                              <label className="expense-title">
                                {ele?.category_name} - ${expense?.amount || '0'}
                              </label>

                              {isCurrentMonth && (
                                <CustomReactSelect
                                  options={recepintOption}
                                  className="com-r-select"
                                  classNamePrefix="com-r-select"
                                  placeholder="Select Member"
                                  value={uiExp?.selectedPayer || null}
                                  onChange={(selectedOption: any) =>
                                    handleSelectPayer(expense.id, selectedOption)
                                  }
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                                  }}
                                />
                              )}
                            </div>

                            {isCurrentMonth && (
                              <div className="paid-checkbox">
                                <label className="paid-label">Paid</label>
                                <Checkbox
                                  id={`paid-checkbox-${expense.id}`}
                                  checked={uiExp?.isPaid || false}
                                  onChange={() => handleTogglePaid(expense.id)}
                                  disabled={markAsPaid?.loading}
                                />
                                {markAsPaid?.loading && (
                                  <span
                                    className="spinner-border spinner-border-sm"
                                    role="status"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        );
                      });
                    })
                  ) : (
                    <div className="text-muted text-center py-3">
                      No unpaid expenses found for the selected period.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="page-padding-x">
            <div className="payment-form mb-4">
              <div
                className="form-header"
                role="button"
                tabIndex={0}
                onClick={() => setVisiblePaymentMethod(!visiblePaymentMethod)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setVisiblePaymentMethod(!visiblePaymentMethod);
                  }
                }}
              >
                <h2 className="dropdown-title">View Payment Methods</h2>
                <img src={addIcon} alt="Arrow" className="arrow-icon" />
              </div>

              {visiblePaymentMethod &&
                <div className="col-12 p-3">
                  <div className="com-input-grp d-flex mt-2">
                    <label className="form-label">For convenience, payment links and IDs can be saved below.</label>
                  </div>
                  {paymentLinksForSelectedUser?.length > 0 ? (
                    paymentLinksForSelectedUser.map((ele: any) => {
                      const isCurrentUser = ele.user_id == profile?.id
                      return (
                        <div key={ele.user_id} className="com-input-grp mt-4">
                          <label className="form-label d-block mb-2" style={{ fontWeight: '600' }}>
                            {ele.user_details?.name}
                          </label>

                          {ele?.paymentMethods?.map((method: any) => (
                            <div
                              key={method.id}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '20px',
                                // marginBottom: '2px',
                                paddingLeft: '0'
                              }}
                            >
                              <label
                                className="form-label d-block"
                                style={{
                                  margin: 0,
                                  minWidth: '80px',
                                  fontWeight: '500'
                                }}
                              >
                                {method.type}
                              </label>

                              <a
                                // href={method?.payment_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  padding: '0',
                                  backgroundColor: 'transparent',
                                  color: '#007bff',
                                  textDecoration: 'none',
                                  fontWeight: '400',
                                  whiteSpace: 'nowrap',
                                  flex: 1
                                }}
                              >
                                {method?.payment_link}
                              </a>

                              {isCurrentUser ? (
                                <span className="btn-delete" style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    console.log("payment_method_id", method.id)
                                    console.log("user_id", profile?.id)
                                    toast.promise(
                                      deletePaymentMethodLinks.makeRequest({
                                        payload: {
                                          "payment_method_id": method.id,
                                          "user_id": profile?.id
                                        },
                                        url: ApiConstants?.deletePaymentMethodLinks, // <-- replace with your API constant name
                                      }).then((res) => {
                                        setPaymentLinksForSelectedUser([])
                                        getPaymentMethodLinks.makeRequest({
                                          payload: { hh_id: profile?.hh_member?.household?.id },
                                          url: ApiConstants?.getPaymentMethodLinks,
                                        }).then((res) => {
                                          if (res?.data) {
                                            let arr = res?.data.sort((a: { user_id: any; }, b: any) => (a.user_id === profile?.id ? 1 : -1));
                                            setPaymentLinksForSelectedUser(arr)
                                          }
                                        })
                                      }),
                                      {
                                        loading: "Deleting link...",
                                        success: "Payment method deleted successfully",
                                        error: "Failed to delete payment method",
                                      },
                                    );
                                  }}>
                                  {/* <i className="icon-delete"></i> */}
                                  <svg className="del-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.25 6.70703H8.75" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                    <path d="M6.125 9.04297H7.875" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                    <path d="M11.375 3.20703L10.7917 12.832H3.20833L2.625 3.20703" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                    <path d="M1.16797 3.20964H4.66797M4.66797 3.20964L5.54297 1.16797H8.45964L9.33464 3.20964M4.66797 3.20964H9.33464M12.8346 3.20964H9.33464" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                  </svg>
                                </span>
                              ) : (
                                <span style={{ width: '50px' }}></span>
                              )}
                            </div>
                          ))}
                        </div>
                      )
                    })
                  ) : (
                    <div
                      className="com-input-grp mt-3"
                      style={{ alignSelf: 'center' }}
                    >
                      <label className="form-label-info d-block">
                        {"No saved payment methods."}
                      </label>
                    </div>
                  )}

                  <div className="divider" />


                  <div className="com-input-grp mt-4">
                    <label className="form-label d-block mb-2">Payment Method</label>
                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Enter payment method"
                      value={paymentMethodInput}
                      onChange={(e) => setPaymentMethodInput(e.target.value)}
                    />

                    <label className="form-label d-block mb-2">{"Link or ID"}</label>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                      <div style={{ flex: 1 }}>
                        <input
                          type="url"
                          className="form-control"
                          placeholder={`Enter Link or ID`}
                          value={paypalUsername}
                          onChange={handleChange}
                        />
                        {paymentMethodLinkError && <p className="valid-error" style={{ marginTop: '5px', marginBottom: 0 }}>{paymentMethodLinkError}</p>}
                      </div>
                      <Button
                        loading={savePaymentMethod?.loading}
                        onClick={() => {
                          const payload = {
                            type: paymentMethodInput,
                            value: paypalUsername,
                            hh_id: profile?.hh_member?.household?.id
                          };
                          _addPaymentMethod(payload);
                        }}
                        className="com-btn p-1"
                        style={{ minWidth: "60px", flexShrink: 0 }}
                      >
                        Add
                      </Button>
                    </div>

                  </div>
                  <>
                    <p style={{
                      fontStyle: 'italic',
                      color: '#999',
                      fontSize: '13px',
                      marginTop: '10px',
                      marginBottom: 0
                    }}>
                      Justivide does not guarantee the accuracy of the links displayed or endorse the
                      services of the third parties listed above.
                    </p>
                  </>

                </div>
              }
            </div>
          </div>

          <PaymentRecord
            isFinalized={isFinalized}
            members={payerOptions}
            recepint={recepintOption}
            callback={() => {
              setTimeout(() => {
                APIcallUnassignedExpenceList();
                getPaymentSummary();
              }, 1000);
            }} />
        </div>
      </div>
      <PaymentChart members={payerOptions} />
      {/* // } */}

      <div className='summary-section'>
        <h3 className='summary-title'>Summary</h3>

        {/* Total Hours Projected */}
        <div
          className='summary-item'
          tabIndex={0}
          role='button'
          aria-expanded={expandedSections.totalPaymentMade}
          onClick={() => toggleSection('totalPaymentMade')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleSection('totalPaymentMade');
            }
          }}
        >
          <div className='summary-item-header'>
            <div className='summary-item-left'>
              <span className='summary-item-label'>Total Payments Made</span>
              <span className='summary-item-arrow'>
                <img className={`accordion-arrow ${expandedSections.totalPaymentMade ? 'expanded' : ''}`} src={chevRight} alt="" />
              </span>
            </div>
            <span className='summary-item-value'>
              ${totalPaymentMade || 0}
            </span>
          </div>
        </div>

        {expandedSections.totalPaymentMade && (
          <div className='summary-item-expanded'>
            {getSummaryList(totalPaymentMadeBy).map((member: any, idx: number) => {
              return (
                <div className='summary-sub-item' key={idx}>
                  <span className='summary-sub-label'>{member.label}</span>
                  <span className='summary-sub-value'>${member.amount}</span>
                </div>
              )
            })}
          </div>
        )}

        <div
          className='summary-item'
          tabIndex={0}
          role='button'
          aria-expanded={expandedSections.totalPaymentReceived}
          onClick={() => toggleSection('totalPaymentReceived')}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              toggleSection('totalPaymentReceived');
            }
          }}
        >
          <div className='summary-item-header'>
            <div className='summary-item-left'>
              <span className='summary-item-label'>Total Payments Received</span>
              <span className='summary-item-arrow'>
                <img className={`accordion-arrow ${expandedSections.totalPaymentReceived ? 'expanded' : ''}`} src={chevRight} alt="" />
              </span>
            </div>
            <span className='summary-item-value'>
              ${totalPaymentReceived || 0}
            </span>
          </div>
        </div>
        {expandedSections.totalPaymentReceived && (
          <div className='summary-item-expanded'>
            {getSummaryList(totalPaymentReceivedBy).map((member: any, idx: number) => {
              return (
                <div className='summary-sub-item' key={idx}>
                  <span className='summary-sub-label'>{member.label}</span>
                  <span className='summary-sub-value'>${member.amount}</span>
                </div>
              )
            })}
          </div>
        )}
      </div>

      <div className='d-flex info-box'>
        <abbr
          data-tooltip-id={"balance-info"}
          className="text-decoration-none cursor-pointer"
        >
          {" "}
          <i className="icon-info ms-2"></i>
        </abbr>
        <label className="info-text">
          All balances are based on information entered or provided by users. Justivide does not guarantee the accuracy of any amounts listed above.
        </label>
      </div>

    </PageLayout>
  );
}

export default Payment;

